import { useEffect, useMemo, useState } from "react";
import { WorkCenter } from "../components/types";
import { DgtPdWorkCenter } from "../models"
import { DataStore } from '@aws-amplify/datastore'

export default function useWorkCenter(keyword: string, refresh: boolean) {
  const [ workCenters, setWorkCenters ] = useState<WorkCenter[]>([])

  useEffect(() => {
    const fetchWorkCenters = async () => {
      const workCenters = await DataStore.query(DgtPdWorkCenter)
      setWorkCenters(workCenters)
    }
    fetchWorkCenters()
  }, [ refresh ])

  const filteredWcs = useMemo(() => {
    return workCenters.filter(wc => wc.id.includes(keyword) || wc.description.toLowerCase().includes(keyword.toLowerCase()))
  }, [ keyword, workCenters ])

  return filteredWcs
}